"use client";
import Link from "next/link";
import styles from "./header.module.css";
import React from "react";
import { useLoginModal, useCartModal } from "states/modals";
import { useCartFetch } from "context/cart";
import useUser from "hooks/useUser";
import { LoggedInModal } from "./header.defered";
import { done } from "nprogress";
export default function HeaderLinks() {
  const { setOpen } = useLoginModal();
  const { data } = useCartFetch();
  const { setOpen: setCartModalOpen } = useCartModal();
  const { data: user } = useUser();

  return (
    <>
      {user ? (
        <LoggedInModal />
      ) : (
        <Link
          href="/login"
          onClick={(e) => {
            e.preventDefault();
            setOpen(true);
            setTimeout(() => {
              done();
            });
          }}>
          My Account
        </Link>
      )}
      <Link
        href="/checkout"
        onClick={(e) => {
          e.preventDefault();
          setCartModalOpen(true);
          setTimeout(() => {
            done();
          });
        }}
        className="btn btn-black"
        style={{
          width: 28,
          height: 28,
          borderRadius: 20,
          padding: 0,
          fontSize: 12,
        }}>
        {data?.length || 0}
      </Link>
    </>
  );
}

export function CalculatorLink({ children }: React.PropsWithChildren) {
  return (
    <Link href="/calculator" className={styles.need}>
      {children}
    </Link>
  );
}

export function VendorLink({ children }: React.PropsWithChildren) {
  const { data, isLoading } = useUser();

  if (isLoading || data) return <></>;

  return (
    <Link href="/login/vendor" prefetch={false}>
      {children}
    </Link>
  );
}
